/* Mirror the live Sternify shop summary; never label store reviews as product reviews. */
(() => {
  if (window.rs2ReviewCardsLoaded) return;
  window.rs2ReviewCardsLoaded = true;
  let pending = false, sequence = 0;
  function sync() {
    pending = false;
    const source = document.querySelector('[id^="st_stars_widget_"]');
    const label = source?.querySelector('.st_display-text')?.textContent.trim();
    const icons = source?.querySelectorAll('.st_stars-wrapper svg');
    if (!label || !/\d/.test(label) || !icons?.length) return;
    const signature = label + [...icons].map(icon => icon.outerHTML).join('');
    document.querySelectorAll('[data-rs2-shop-review-card]').forEach(card => {
      if (card.rs2ReviewSignature === signature) return;
      card.rs2ReviewSignature = signature;
      const stars = document.createElement('span');
      stars.className = 'rs2-rating-stars';
      stars.setAttribute('aria-hidden', 'true');
      icons.forEach(icon => {
        const clone = icon.cloneNode(true), prefix = `rs2-star-${++sequence}-`;
        const ids = new Map();
        clone.querySelectorAll('[id]').forEach(node => { ids.set(node.id, prefix + node.id); node.id = prefix + node.id; });
        clone.querySelectorAll('*').forEach(node => {
          for (const attribute of [...node.attributes]) {
            let value = attribute.value;
            ids.forEach((next, old) => { value = value.replaceAll(`url(#${old})`, `url(#${next})`); if (value === '#' + old) value = '#' + next; });
            if (value !== attribute.value) node.setAttribute(attribute.name, value);
          }
        });
        stars.append(clone);
      });
      const text = document.createElement('span');text.textContent = label;
      card.replaceChildren(stars, text);
      card.setAttribute('aria-label', label);
      card.hidden = false;
    });
  }
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(sync); } };
  const start = () => { sync(); new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,characterData:true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
